import React, { useEffect } from "react";
import axios from "utils/api";
import { useHistory } from "react-router-dom";
import { Alert, Card, CardHeader, Media, Col } from "reactstrap";

const Activation = () => {
  let history = useHistory();

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      axios.get(`merchant/validatetoken?token=${new URL(window.location.href).searchParams.get('token')}`)
        .then(response => {
          if (response.data) {
            // localStorage.setItem('userId', response.data.userId);
            // localStorage.setItem('enforcePasswordHistory', response.data.enforcePasswordHistory);
            localStorage.setItem('validationToken', response.data.token);

            history.push('/auth/changepassword', {from: `validatetoken`});
          } else {
            history.push('/auth/invalidtoken');
          }
        })
        .catch((error) => {
          alert(`There was an error validating the token. Please try again later.`);
        });
    } 

    return () => {
      mounted = false;
    };
  }, [history]);

  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
            <CardHeader className="bg-transparent pb-5">
                <p style={{textAlign:"center"}}>
                  <Media object width="100" style={{marginTop: "20px"}} src={require("assets/img/brand/biometrics.png")} 
                    alt="Account activation image" />
                </p>
                <Alert color="warning">
                  <span className="alert-text"> 
                    <h4 className="alert-heading">Validating Token</h4> 
                  </span>
                  <p>We are validating your token. This won't take a long...</p>
                </Alert>
            </CardHeader>
        </Card>
      </Col>
    </>
  );
}

export default Activation;
